module.exports = __webpack_public_path__ + "static/media/pbsolving.905d388c.svg";